// extracted by mini-css-extract-plugin
export default {"scouting-red":"Popover__scouting-red___LPitE","noArrow":"Popover__noArrow___qHiO0","noPadding":"Popover__noPadding___ll9Fu"};